import { last, match, isNil } from 'ramda';
// Simplified My Account - http://busfor.dev.ru:3000/ru/new/account/FuEo7q4J5SaWit6Qj6zBGAMy/orders/47045159
const simpleRoutes = currentLocale => ({
  index: {
    path: `/${currentLocale}/new/account`,
    to: `/${currentLocale}/new/account`
  },
  order: {
    path: `/${currentLocale}/new/account/:orderToken/orders/:orderId`,
    to: (orderId, orderToken) => `/${currentLocale}/new/account/${orderToken}/orders/${orderId}`,
    comment: {
      path: `/${currentLocale}/new/account/:orderToken/orders/:orderId/comment`,
      to: (orderId, orderToken) => `/${currentLocale}/new/account/${orderToken}/orders/${orderId}/comment`
    },
    return: {
      path: `/${currentLocale}/new/account/:orderToken/orders/:orderId/refund`,
      to: (orderId, orderToken) => `/${currentLocale}/new/account/${orderToken}/orders/${orderId}/refund`
    }
  }
});
const defaultRoutes = currentLocale => ({
  index: {
    path: `/${currentLocale}/new/account`,
    to: `/${currentLocale}/new/account`
  },
  history: {
    path: `/${currentLocale}/new/account/history`,
    to: `/${currentLocale}/new/account/history`
  },
  customer: {
    path: `/${currentLocale}/new/account/customer`,
    to: `/${currentLocale}/new/account/customer`
  },
  order: {
    path: `/${currentLocale}/new/account/orders/:orderId`,
    to: orderId => `/${currentLocale}/new/account/orders/${orderId}`,
    comment: {
      path: `/${currentLocale}/new/account/orders/:orderId/comment`,
      to: orderId => `/${currentLocale}/new/account/orders/${orderId}/comment`
    },
    return: {
      path: `/${currentLocale}/new/account/orders/:orderId/refund`,
      to: orderId => `/${currentLocale}/new/account/orders/${orderId}/refund`
    }
  },
  reviews: {
    path: `/${currentLocale}/new/account/reviews`
  }
});
const getOrderToken = () => {
  const regExp = new RegExp('^\\/[a-zA-Z]*\\/new\\/account\\/(.+)\\/orders\\/\\d+');
  return global.location && last(match(regExp, global.location.pathname));
};
const routers = currentLocale => {
  const orderToken = getOrderToken();
  return isNil(orderToken) ? defaultRoutes(currentLocale) : simpleRoutes(currentLocale);
};
export default routers;
export const orderToken = getOrderToken();